import { Image, Tag } from "antd";
import { StarOutlined } from "@ant-design/icons";
import { IMAGE_NOT_FOUND } from "constants/common";
import { getImageFullPath } from "utils/image";

interface MobileOrderItemProps {
  name: string;
  price: number;
  qty: number;
  url: string;
  isRedemptionItem?: boolean;
  redemptionItem?: {
    id: number;
    name: string;
    description: string;
    type: string;
    pointsCost: number;
    cashCost: number;
  };
  pointsUsed?: number;
  cashUsed?: number;
}

const MobileOrderItem = ({
  name,
  price,
  qty,
  url,
  isRedemptionItem = false,
  redemptionItem,
  pointsUsed,
  cashUsed,
}: MobileOrderItemProps) => {
  return (
    <div className="mb-4">
      <div className="flex gap-4">
        <Image
          src={getImageFullPath(url)}
          width={90}
          height={90}
          alt={name}
          className="object-contain"
          fallback={IMAGE_NOT_FOUND}
        />
        <div className="flex-1 flex flex-col justify-between">
          <div className="line-clamp-2 mb-2">
            {name}
            {isRedemptionItem && (
              <div className="mt-1">
                <Tag color="purple" icon={<StarOutlined />}>
                  สินค้าแลกคะแนน
                </Tag>
                {redemptionItem && (
                  <div className="text-xs text-gray-600 mt-1">
                    <div>{redemptionItem.description}</div>
                    <div className="mt-1">
                      {redemptionItem.pointsCost} คะแนน
                      {redemptionItem.type === "HYBRID" &&
                        ` + ${redemptionItem.cashCost} บาท`}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="flex justify-between">
            <div className="text-gray-500">จำนวน: {qty}</div>
            {isRedemptionItem ? (
              <div className="font-semibold">
                <div className="text-purple-600">
                  {((pointsUsed || 0) * qty).toLocaleString()} คะแนน
                </div>
                {cashUsed && cashUsed > 0 && (
                  <div className="text-sm">
                    + ฿{(cashUsed * qty).toLocaleString()}
                  </div>
                )}
              </div>
            ) : (
              <div className="font-semibold">
                ฿{(qty * price).toLocaleString()}
              </div>
            )}
          </div>
          <div className="text-sm text-gray-500">
            {isRedemptionItem ? (
              <div>
                <div className="text-purple-600">
                  {pointsUsed} คะแนน ต่อหน่วย
                </div>
                {cashUsed && cashUsed > 0 && (
                  <div>+ ฿{cashUsed.toLocaleString()} ต่อหน่วย</div>
                )}
              </div>
            ) : (
              <div>฿{price.toLocaleString()} ต่อหน่วย</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileOrderItem;
